export { appWithI18Next } from './app-with-i18next';
